import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CasesTableView } from 'dashboard/models/table-view';

export interface TableViewState {
  tableViews: CasesTableView[];
  currentTableViewId: string;
}

export const initialState: TableViewState = {
  tableViews: [],
  currentTableViewId: '',
};

interface SetTableViewsPayload {
  tableViews: CasesTableView[];
}

interface SetCurrentTableViewIdPayload {
  currentTableViewId: string;
}

const { reducer, actions } = createSlice({
  name: 'table-views',
  initialState,
  reducers: {
    setTableViews: (state, action: PayloadAction<SetTableViewsPayload>) => {
      state.tableViews = action.payload.tableViews;
    },
    setCurrentTableViewId: (state, action: PayloadAction<SetCurrentTableViewIdPayload>) => {
      state.currentTableViewId = action.payload.currentTableViewId;
    },
  },
});

export const { setTableViews, setCurrentTableViewId } = actions;
export const tableViewsReducer = reducer;
